import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import {
  fetchUserDriveSchool,
  setPage,
} from "../../store/slices/userDriveSchoolSlice";
import "react-toastify/dist/ReactToastify.css";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const TableUserDriveSchool = () => {
  const dispatch = useDispatch();

  const dataUser = useSelector((state) => state.userDriveSchoolSlice.data);
  const totalCount = useSelector(
    (state) => state.userDriveSchoolSlice.totalCount
  );
  const currentPage = useSelector(
    (state) => state.userDriveSchoolSlice.currentPage
  );
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      fetchUserDriveSchool({ page: currentPage, searchQuery: searchInput })
    );
  }, [dispatch, currentPage, searchInput]);

  const handleSearchInputChange = (e) => setSearchInput(e.target.value);
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      fetchUserDriveSchool({ page: currentPage, searchQuery: searchInput })
    );
  };
  const handlePageChange = (page) => dispatch(setPage(page));

  return (
    <div className="px-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
      </div>

      {/* Responsive Card View for Mobile */}
      <div className="block lg:hidden space-y-4">
        {dataUser?.data?.map((item) => (
          <div
            key={item.userId + item.id}
            className="bg-white rounded-lg shadow-md p-4"
          >
            <div className="text-sm mb-2">
              <p>
                <span className="font-semibold">Emri dhe mbiemri:</span>{" "}
                {item.name}
              </p>
              <p>
                <span className="font-semibold">Numri i telefonit:</span>{" "}
                {item.phoneNumber}
              </p>
              <p>
                <span className="font-semibold">Qyteti:</span> {item.city}
              </p>
            </div>

            <p className="text-blue-600 font-semibold mb-2">
              Progresi i testimit
            </p>
            <div className="flex items-center gap-4">
              <div style={{ width: 55, height: 55 }}>
                <CircularProgressbarWithChildren
                  value={Math.min(
                    parseFloat(item.testProgress.percentageCorrect),
                    100
                  )}
                  strokeWidth={8}
                  styles={buildStyles({
                    pathColor: "#22c55e",
                    trailColor: "#ef4444",
                    strokeLinecap: "butt",
                    textColor: "#22c55e",
                  })}
                >
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      color: "#22c55e",
                    }}
                  >
                    {item.testProgress.percentageCorrect}%
                  </div>
                </CircularProgressbarWithChildren>
              </div>

              <div className="text-xs">
                <div className="flex items-center space-x-1">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-green-600 font-medium">Kaluar</span>
                  <span className="text-gray-900 font-bold ml-2">
                    {item.testProgress.passedPercentage ?? 0}%
                  </span>
                </div>
                <div className="flex items-center space-x-1 mt-1">
                  <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                  <span className="text-red-600 font-medium">Dështuar</span>
                  <span className="text-gray-900 font-bold ml-2">
                    {item.testProgress.notPassedPercentage ?? 0}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Table View for Desktop */}
      <div className="hidden lg:block overflow-x-auto rounded-lg shadow-md bg-white mt-4">
        <table className="min-w-full table-auto text-sm text-left text-gray-700">
          <thead className="text-xs text-[#718EBF] bg-white">
            <tr>
              <th className="px-4 py-3">Emri dhe Mbiemri</th>
              <th className="px-4 py-3">Numri Telefonit</th>
              <th className="px-4 py-3">Qyteti</th>
              <th className="px-4 py-3">Progresi i testimit</th>
            </tr>
          </thead>
          <tbody>
            {dataUser?.data?.map((item) => (
              <tr
                key={item.userId + item.id}
                className="border-t hover:bg-gray-50"
              >
                <td className="px-4 py-3">{item.name}</td>
                <td className="px-4 py-3">{item.phoneNumber}</td>
                <td className="px-4 py-3">{item.city}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <div style={{ width: 55, height: 55 }}>
                      <CircularProgressbarWithChildren
                        value={Math.min(
                          parseFloat(item.testProgress.percentageCorrect),
                          100
                        )}
                        strokeWidth={8}
                        styles={buildStyles({
                          pathColor: "#22c55e",
                          trailColor: "#ef4444",
                          strokeLinecap: "butt",
                          textColor: "#22c55e",
                        })}
                      >
                        <div
                          style={{
                            fontSize: 10,
                            fontWeight: "bold",
                            color: "#22c55e",
                          }}
                        >
                          {item.testProgress.passedPercentage}%
                        </div>
                      </CircularProgressbarWithChildren>
                    </div>

                    <div className="text-xs sm:text-sm">
                      <div className="flex items-center space-x-1">
                        <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                        <span className="text-green-600 font-medium">
                          Kaluar
                        </span>
                        <span className="text-gray-900 font-bold ml-2">
                          {item.testProgress.passedPercentage ?? 0}%
                        </span>
                      </div>
                      <div className="flex items-center space-x-1 mt-1">
                        <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                        <span className="text-red-600 font-medium">
                          Dështuar
                        </span>
                        <span className="text-gray-900 font-bold ml-2">
                          {item.testProgress.notPassedPercentage ?? 0}%
                        </span>
                      </div>
                      <div className="flex items-center space-x-1 mt-1">
                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                        <span className="text-blue-600 font-medium">
                          Pa plotësuar
                        </span>
                        <span className="text-gray-900 font-bold ml-2">
                          {item.testProgress.notEnteredPercentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalCount={totalCount}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TableUserDriveSchool;
